import React from "react";

export default function About() {
  return (
    <div className="tk-container py-20 max-w-3xl" data-testid="about-page">
      <p className="tk-overline mb-3">Om oss</p>
      <h1 className="text-3xl sm:text-4xl font-semibold mb-6">Vi gjør Apple-reparasjon enkelt</h1>
      <p className="text-base text-slate-600 leading-relaxed mb-6">
        Tekkdeler er en norsk plattform som kobler deg med kvalitetsdeler og lokale,
        dyktige verksteder. Vi mener at reparasjon skal være enkelt, trygt og rimelig —
        for deg og for miljøet.
      </p>
      <p className="text-base text-slate-600 leading-relaxed mb-6">
        Alle verksteder i Tekkdeler-nettverket er håndplukkede partnere som vi jobber tett
        med for å sikre god service og riktige priser. Du betaler trygt med Vipps eller
        kort, og delene sendes direkte til verkstedet.
      </p>
      <p className="text-base text-slate-600 leading-relaxed">
        Vi er et ungt selskap i vekst, med base i Oslo. Målet vårt er å gjøre det like
        enkelt å reparere Apple-enheten din som å bestille pizza.
      </p>
    </div>
  );
}
